// extracted by mini-css-extract-plugin
export default {"parentView":"style_parentView__PqC74","contentsView":"style_contentsView__OP9Ms","closeBtn":"style_closeBtn__EyMAh"};